import { string, shape, array, arrayOf } from "prop-types";
import { RichText } from "./RichText";
import styles from "./styles/TitleWithBody.module.css";

export const TitleWithBody = ({ data }) => {
  return (
    <section className={styles.container}>
      <h1 className={styles.title}>{data.title}</h1>
      <RichText data={data.body} />
    </section>
  );
};

TitleWithBody.propTypes = {
  _key: string,
  _type: string,
  title: string,
  body: shape({
    _type: string,
    content: arrayOf(
      shape({
        _key: string,
        _type: string,
        style: string,
        children: arrayOf(
          shape({
            _key: string,
            _type: string,
            marks: array,
            text: string,
          })
        ),
        markDefs: array,
      })
    ),
  }),
};
